import React from 'react';
import Button from '../../common/Button';

export default class EditorRestoreFromSnapshotAlert extends React.Component {
    render() {
        const addLeadingZero = x => (x < 10 ? '0' + x : x)
        let snapshotTime = new Date(this.props.snapshotTime)
        snapshotTime = `
            ${addLeadingZero(snapshotTime.getDate())}.${addLeadingZero(snapshotTime.getMonth())}.${snapshotTime.getFullYear()} 
            ${addLeadingZero(snapshotTime.getHours())}:${addLeadingZero(snapshotTime.getMinutes())}`

        return (
            <div className="configuration-editor-snapshot-alert">
                <div>
                    {__('It looks like there was some communication problem last time, but a snapshot has been taken.')}<br/>
                    {__('Do you want to load the snapshot from')} {snapshotTime}?<br/><br/>

                    <div className="configuration-editor-snapshot-alert-buttons">
                        <Button theme={Button.Theme.BorderOnly} color={Button.Color.White}
                                onClick={this.props.onLoadSnapshotClick}>{__('Load snapshot')}</Button>
                        <Button theme={Button.Theme.BorderOnly} color={Button.Color.White}
                                onClick={this.props.onIgnoreClick}>{__('Ignore')}</Button>
                    </div>
                </div>
            </div>
        )
    }
}